import { useCallback, useMemo, useState } from 'react';
import { AnalogInput, AnalogTemperatureSensor, RadioSensor, WiredTemperatureSensor, } from 'z3k-config';
import * as lodash from 'lodash';
import { deepDiff } from 'webui/utils/objects';
import { constructorForTreeComponent } from 'shared/device.z3k.tree-view-compare/utils/constructor-for-tree';
import { useBox } from 'shared/hooks/utils';
import { deepConfigCompare } from 'shared/hooks/device/z3k.compare/deep-config-compare';
export const useComparisonConfig = (exist_config) => {
    //нужен для активации кнопки применить считает кол-во настроек
    const [count, setCount] = useState(0);
    //результат сравнения отправляемый в tree
    const [resultCompare, setResultCompare] = useState(null);
    //фильтруем текущий конфиг
    const exist_config_before_compare = useMemo(() => ({
        ...exist_config,
        ...(exist_config?.analog_inputs && {
            analog_inputs: exist_config.analog_inputs?.map((el) => lodash.omit(AnalogInput.convertThresholds(el), ['voltage'])),
        }),
        ...(exist_config?.heating_modes && {
            heating_modes: exist_config.heating_modes?.map((el) => ({
                ...el,
                ...(!el.force_boiler_mode && { force_boiler_mode: false }),
            })),
        }),
        ...(exist_config?.heating_circuits && {
            heating_circuits: exist_config.heating_circuits.map((el) => ({
                ...el,
                ...(el?.locker_id === 0 && { locker_id: null }),
                ...((el.water_max_temperature === 0 ||
                    el.water_max_temperature === '') && {
                    water_max_temperature: null,
                }),
                ...((el.water_min_temperature === 0 ||
                    el.water_min_temperature === '') && {
                    water_min_temperature: null,
                }),
            })),
        }),
        ...(exist_config?.wired_temperature_sensors && {
            wired_temperature_sensors: exist_config?.wired_temperature_sensors?.map(WiredTemperatureSensor.convertThresholds),
        }),
        ...(exist_config?.analog_temperature_sensors && {
            analog_temperature_sensors: exist_config?.analog_temperature_sensors?.map(AnalogTemperatureSensor.convertThresholds),
        }),
        ...(exist_config?.radiosensors && {
            radiosensors: exist_config?.radiosensors?.map(RadioSensor.convertThresholds),
        }),
    }), [exist_config]);
    const boxedExistConfig = useBox(exist_config_before_compare);
    //фильтруем новый файл
    const new_data_before_compare = useCallback((newData) => ({
        ...newData,
        ...(newData.analog_inputs && {
            analog_inputs: newData.analog_inputs?.map((el) => lodash.omit(AnalogInput.convertThresholds(el), ['voltage'])),
        }),
        ...(newData.heating_circuits && {
            heating_circuits: newData.heating_circuits?.map((el) => ({
                ...el,
                ...(el?.locker_id === 0 && { locker_id: null }),
                ...((el.water_max_temperature === 0 ||
                    el.water_max_temperature === '') && {
                    water_max_temperature: null,
                }),
                ...((el.water_min_temperature === 0 ||
                    el.water_min_temperature === '') && {
                    water_min_temperature: null,
                }),
            })),
        }),
        ...(newData.heating_modes && {
            heating_modes: newData.heating_modes?.map((el) => ({
                ...el,
                ...(!el.force_boiler_mode && { force_boiler_mode: false }),
            })),
        }),
        ...(newData?.wired_temperature_sensors && {
            wired_temperature_sensors: newData?.wired_temperature_sensors?.map(WiredTemperatureSensor.convertThresholds),
        }),
        ...(newData?.analog_temperature_sensors && {
            analog_temperature_sensors: newData?.analog_temperature_sensors?.map(AnalogTemperatureSensor.convertThresholds),
        }),
        ...(newData?.radiosensors && {
            radiosensors: newData?.radiosensors?.map(RadioSensor.convertThresholds),
        }),
        ...(newData.gsm_settings && {
            gsm_settings: {
                ...newData.gsm_settings,
                threshold: newData.gsm_settings?.threshold.toString(),
            },
        }),
        ...(exist_config?.apn && { apn: exist_config.apn }),
        ...(exist_config?.counters && { counters: exist_config.counters }),
        ...(exist_config?.device && { device: exist_config.device }),
        ...(exist_config?.login && { login: exist_config.login }),
        ...(exist_config?.password && { password: exist_config.password }),
        ...(exist_config?.port && { port: exist_config.port }),
        ...(exist_config?.servers && { servers: exist_config.servers }),
    }), [exist_config]);
    //находит различия без углубления во вложенные объекты
    const generalCompare = useCallback((newData) => {
        setCount(0);
        setResultCompare(null);
        return lodash.omitBy(deepDiff(new_data_before_compare(newData), boxedExistConfig.current), lodash.isNil);
    }, []);
    //вывод объект с результатом новых и старых настроек (подробный)
    const deepCompare = useCallback((general_compare_result) => {
        const data = deepConfigCompare(general_compare_result, boxedExistConfig.current);
        if (data?.compare_result) {
            //отправляем на обработку для вывода в компоненте tree
            constructorForTreeComponent(data.compare_result, setResultCompare);
            setCount(data.count);
        }
        else {
            return setResultCompare(null);
        }
    }, []);
    const compare = useCallback((new_config) => {
        deepCompare(generalCompare(new_config));
    }, [generalCompare, deepCompare]);
    return [resultCompare, count, compare];
};
